import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import WebService from "../../../../../utility/WebService";
import { Controller, useForm } from "react-hook-form";
import loader from "../../../../../assets/images/button-loader.svg"
import WarningModal from "../../../../../components/Warning/Warning";
import SucessModal from "../../../../../components/SucessModal/Sucess";
import CustomDropdown, { Options } from "../../../../../components/Select/CustomDropdown";
import { SkeletonBar } from "../../../../../components/Skeleton/Skeleton";
// @ts-ignore
import "./AddFixedReturnandRetirementProducts.css";
import { useMenuBack } from "../../../../../hooks/useMenuBack";

/* ---- small inline field icons (kept local to this screen) ---- */
const IconLayers = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2 2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" /></svg>
);
const IconSliders = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><line x1="4" y1="21" x2="4" y2="14" /><line x1="4" y1="10" x2="4" y2="3" /><line x1="12" y1="21" x2="12" y2="12" /><line x1="12" y1="8" x2="12" y2="3" /><line x1="20" y1="21" x2="20" y2="16" /><line x1="20" y1="12" x2="20" y2="3" /><line x1="1" y1="14" x2="7" y2="14" /><line x1="9" y1="8" x2="15" y2="8" /><line x1="17" y1="16" x2="23" y2="16" /></svg>
);
const IconTag = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.6 13.4L11 3.8A2 2 0 009.6 3.2H4a1 1 0 00-1 1v5.6a2 2 0 00.6 1.4l9.6 9.6a2 2 0 002.8 0l4.6-4.6a2 2 0 000-2.8z" /><circle cx="7.5" cy="7.5" r="1.2" /></svg>
);
const IconBank = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l9 5H3l9-5z" /><path d="M5 21V10m14 11V10M9.5 21v-6m5 6v-6" /><path d="M3 21h18" /></svg>
);
const IconBuilding = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="3" width="16" height="18" rx="1.5" /><path d="M9 8h.01M15 8h.01M9 12h.01M15 12h.01M9 16h.01M15 16h.01" /></svg>
);
const IconBriefcase = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="2.5" y="7" width="19" height="13" rx="2" /><path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" /></svg>
);
const IconShield = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z" /></svg>
);
const IconUsers = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3.2" /><path d="M2 20c0-3.3 3.1-5 7-5s7 1.7 7 5" /><path d="M16 5.2A3 3 0 0116 11m6 9c0-2.5-1.6-4-4-4.6" /></svg>
);
const IconHash = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><line x1="4" y1="9" x2="20" y2="9" /><line x1="4" y1="15" x2="20" y2="15" /><line x1="10" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="14" y2="21" /></svg>
);
const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 018 0v3" /></svg>
);
const IconPercent = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="5" x2="5" y2="19" /><circle cx="7" cy="7" r="2.2" /><circle cx="17" cy="17" r="2.2" /></svg>
);
const IconStar = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l2.7 5.5 6 .9-4.3 4.2 1 6L12 17l-5.4 2.6 1-6L3.3 9.4l6-.9L12 3z" /></svg>
);
const IconCash = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="6" width="20" height="12" rx="2" /><circle cx="12" cy="12" r="2.6" /><path d="M6 10v4m12-4v4" /></svg>
);
const IconRefresh = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 01-9 9 9 9 0 01-6.7-3M3 12a9 9 0 019-9 9 9 0 016.7 3" /><path d="M21 3v5h-5M3 21v-5h5" /></svg>
);
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4m8-4v4" /></svg>
);
const IconNote = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16v12l-5 5H4z" /><path d="M15 21v-5h5M8 9h8M8 13h5" /></svg>
);
const IconError = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 8v4m0 4h.01" /></svg>
);
const IconBack = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
);

/* ---- page-specific skeleton shown while the edit record loads ---- */
const ProductFormSkeleton = () => (
  <>
    <div className="afrp-card" aria-hidden="true">
      <div className="afrp-card-head">
        <SkeletonBar w={38} h={38} r={11} />
        <div>
          <SkeletonBar w={170} h={16} />
          <SkeletonBar w={210} h={11} style={{ marginTop: 8 }} />
        </div>
      </div>
      <div className="afrp-fields">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <div key={i}>
            <SkeletonBar w={120} h={12} style={{ marginBottom: 10 }} />
            <SkeletonBar w="100%" h={42} r={10} />
          </div>
        ))}
      </div>
    </div>
    <div className="afrp-card" aria-hidden="true">
      <div className="afrp-card-head">
        <SkeletonBar w={38} h={38} r={11} />
        <div>
          <SkeletonBar w={150} h={16} />
          <SkeletonBar w={210} h={11} style={{ marginTop: 8 }} />
        </div>
      </div>
      <div className="afrp-fields">
        {[0, 1, 2, 3].map((i) => (
          <div key={i}>
            <SkeletonBar w={120} h={12} style={{ marginBottom: 10 }} />
            <SkeletonBar w="100%" h={42} r={10} />
          </div>
        ))}
      </div>
    </div>
  </>
);

const AddFixedReturnandRetirementProducts = () => {
  const goBack = useMenuBack();
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        control,
        formState: { errors },
    } = useForm();
    const watchAllFields = watch();
    const [isLoading, setLoading] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [bankNameOption, setBankNameOption] = useState<any[]>([]);
    const [bankValue, setBankValue] = useState<any[]>([]);
    const [financialInstituteOption, setFinancialInstituteOption] = useState<any[]>([]);
    const [financialInstituteValue, setFinancialInstituteValue] = useState<any[]>([]);
    const [publicCompanyOption, setPublicCompanyOption] = useState<any[]>([]);
    const [publicCompanyValue, setPublicCompanyValue] = useState<any[]>([]);
    const [insuranceCompanyOption, setInsuranceCompanyOption] = useState<any[]>([]);
    const [insuranceCompanyValue, setInsuranceCompanyValue] = useState<any[]>([]);
    const [p2pLenderOption, setp2pLenderOption] = useState<any[]>([]);
    const [p2pLenderValue, setP2pLenderValue] = useState<any[]>([]);
    const [bondsandDebentureOption, setBondsandDebentureOption] = useState<any[]>([]);
    const [bondsandDebentureValue, setBondsandDebentureValue] = useState<any[]>([]);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [productCategories, setProductCategories] = useState<any>([]);
    const [issuerData, setIssuerData] = useState<any>([]);
    const [vendorLockingSelected, setVendorLockingSelected] = useState<any[]>([]);
    const [lockingIncomeTaxSelected, setLockingIncomeTaxSelected] = useState<any[]>([]);

    let { id } = useParams();

    useEffect(() => {
        if (id) {
            getDetail();
        }
        getProductCategoriesList()
        getIssuerList();
        getBankList();
        getFinancialInstituteList();
        getPublicCompanyList();
        getInsuranceCompanyList();
        getP2pLenderList();
        getBondsandDebentureList();
    }, []);

    const onSave = (data: any) => {
        setLoading(true);
        if (id) {
            WebService.putAPI({
                action: `/v2/CommonProductParameters/AddData`,
                body: data,
            })
                .then((res: any) => {
                    setShowSucessModal(true);
                    setSucessMessage(res.message)
                    goBack();
                })
                .catch((e) => {
                    setShowWarningModal(true);
                    setWarningMessage(e.response.data.message)
                    setLoading(false);
                });
        } else {
            WebService.postAPI({
                action: `/v2/CommonProductParameters/AddData`,
                body: data,
            })
                .then((res: any) => {
                    setShowSucessModal(true);
                    setSucessMessage(res.message)
                    goBack();
                })
                .catch((e) => {
                    setShowWarningModal(true);
                    setWarningMessage(e.response.data.message)
                    setLoading(false);
                });
        }
    };

    const getProductCategoriesList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/ProductParameteTypeList`,
        })
            .then((res: any) => {
                setProductCategories(res.list)
            })
            .catch((e) => {
            });
    };

    const getIssuerList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/IssuerCategoryList`,
        })
            .then((res: any) => {
                setIssuerData(res.list)
            })
            .catch((e) => {
            });
    };

    const getBankList = () => {
        WebService.postAPI({
            action: `/v2/BankList/getlist`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].bank_list_id, value: res.list[i].name });
                }
                setBankNameOption(array);
            })
            .catch((e) => { });
    };

    const getFinancialInstituteList = () => {
        WebService.postAPI({
            action: `/v2/FinancialInstituteType/GetList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].financial_institute_type_id, value: res.list[i].name });
                }
                setFinancialInstituteOption(array);
            })
            .catch((e) => { });
    };

    const getPublicCompanyList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/GetList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setPublicCompanyOption(array);
            })
            .catch((e) => { });
    };

    const getInsuranceCompanyList = () => {
        WebService.postAPI({
            action: `/v2/UlipProductParameters/GetInsuranceCompanyList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setInsuranceCompanyOption(array);
            })
            .catch((e) => { });
    };

    const getP2pLenderList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/GetLenderList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setp2pLenderOption(array);
            })
            .catch((e) => { });
    };

    const getBondsandDebentureList = () => {
        WebService.postAPI({
            action: `/v2/CommonProductParameters/GetBondsAndDebenturesTypeList`,
            body: null,
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setBondsandDebentureOption(array);
            })
            .catch((e) => { });
    };

    const vendorLockingOptions: Options[] = [
        { id: "Year", value: "Year" },
        { id: "Month", value: "Month" },
        { id: "Day", value: "Day" },
        { id: "Description", value: "Description" },
    ];

    const compoundingFrequencyOptions: Options[] = [
        { id: "Yearly", value: "Yearly" },
        { id: "Half-Yearly", value: "Half-Yearly" },
        { id: "Quarterly", value: "Quarterly" },
        { id: "Monthly", value: "Monthly" },
        { id: "NA", value: "NA" },
    ];

    const getDetail = () => {
        setShowLoader(true);
        WebService.postAPI({
            action: `/v2/CommonProductParameters/GetDetail?id=${id}`,
        })
            .then((res: any) => {
                reset(res.result);
                setBondsandDebentureValue(res.result.bonds_and_debentures_type_id);
                setBankValue(res.result.bank_id);
                setFinancialInstituteValue(res.result.financial_institute_type_id);
                setPublicCompanyValue(res.result.share_company_id);
                setInsuranceCompanyValue(res.result.insurance_company_id);
                setP2pLenderValue(res.result.table_id);
                setVendorLockingSelected(res.result.locking_period_by_vendor_term);
                setLockingIncomeTaxSelected(res.result.locking_period_by_income_tax_term)
                setShowLoader(false);
            })
            .catch((e) => {
                setShowLoader(false);
                setShowWarningModal(true);
                setWarningMessage(e.response.data.message)
            });
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setLoading(false);
    }

    
    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <div className="page-content-wraper afrp-page">
                <form onSubmit={handleSubmit(onSave)}>
                    {/* ---------- top bar ---------- */}
                    <div className="afrp-topbar">
                        <div className="afrp-crumb">
                            <button type="button" className="afrp-back" onClick={goBack} title="Back">
                                <IconBack />
                            </button>
                            <div>
                                <h1>{id ? "Edit Fixed Return & Retirement Product" : "Add Fixed Return & Retirement Product"}</h1>
                                <p>Product Parameter · Fixed Return & Retirement</p>
                            </div>
                        </div>
                        <div className="afrp-actions">
                            <button
                                type="button"
                                className="btn btn-white"
                                onClick={goBack}
                            >
                                Cancel
                            </button>
                            <button className="btn btn-brand" type="submit">
                                {isLoading && <img src={loader} className="spinner" alt="" />}
                                Save
                            </button>
                        </div>
                    </div>

                    {showLoader ? (
                        <ProductFormSkeleton />
                    ) : (
                        <>
                            {/* ---------- card 1 : classification ---------- */}
                            <div className="afrp-card">
                                <div className="afrp-card-head">
                                    <div className="afrp-badge">
                                        <IconLayers />
                                    </div>
                                    <div>
                                        <h2>Product Classification</h2>
                                        <p>
                                            Fields marked <span style={{ color: "var(--afrp-red)" }}>*</span> are required
                                        </p>
                                    </div>
                                </div>

                                <div className="afrp-fields">
                                    {/* Product Category */}
                                    <div className={"afrp-field" + (errors.product_parameter_type ? " is-invalid" : "")}>
                                        <label className="afrp-lab">
                                            <IconLayers /> Product Category <span className="afrp-req">*</span>
                                        </label>
                                        <select
                                            className="form-control"
                                            {...register("product_parameter_type", {
                                                required: true,
                                            })}
                                            onChange={(e) => {
                                                setValue('product_parameter_type', e.target.value)
                                                setValue('issuer_category', null)
                                            }}>
                                            {productCategories &&
                                                productCategories.length > 0 &&
                                                productCategories.map((res: any) => {
                                                    return (
                                                        <optgroup label={res.name} >
                                                            <option value={''}>Select</option>
                                                            {res &&
                                                                res.list.length > 0 &&
                                                                res.list.map((item: any) => {
                                                                    return (
                                                                        <option value={item.id}>{item.name}</option>
                                                                    );
                                                                })}
                                                        </optgroup>
                                                    );
                                                })}
                                        </select>
                                        {errors.product_parameter_type && (
                                            <p className="afrp-err">
                                                <IconError /> Please Enter Product Category.
                                            </p>
                                        )}
                                    </div>

                                    {watchAllFields.product_parameter_type == "Debentures" &&
                                        <div className={"afrp-field" + (errors.bonds_and_debentures_type_id ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconTag /> Bonds &amp; Debentures Type <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="bonds_and_debentures_type_id"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <CustomDropdown
                                                        isSearchable={true}
                                                        options={bondsandDebentureOption}
                                                        selected={bondsandDebentureValue}
                                                        onChange={(data: any) => {
                                                            field.onChange(data.id)
                                                            setBondsandDebentureValue(data.id);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.bonds_and_debentures_type_id && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Bonds &amp; Debentures Type .
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "Recurring" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "POMIS" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "NPS" || watchAllFields.product_parameter_type == "Superannuation") &&
                                        <div className={"afrp-field afrp-wide" + (errors.issuer_category ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconBank /> Issuer <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="issuer_category"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <div className="sh-seg">
                                                        {issuerData &&
                                                            issuerData.length > 0 &&
                                                            issuerData.map((res: any) => {
                                                                return (
                                                                    <button
                                                                        type="button"
                                                                        key={res.name}
                                                                        className={"sh-seg-opt" + (field.value === res.name ? " on" : "")}
                                                                        onClick={() => field.onChange(res.name)}
                                                                    >
                                                                        {res.name}
                                                                    </button>
                                                                );
                                                            })}
                                                    </div>
                                                )}
                                            />
                                            {errors.issuer_category && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Issuer.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {(watchAllFields.issuer_category == 'Bank') &&
                                        <div className={"afrp-field" + (errors.bank_id ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconBank /> Bank <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="bank_id"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <CustomDropdown
                                                        isSearchable={true}
                                                        options={bankNameOption}
                                                        selected={bankValue}
                                                        onChange={(data: any) => {
                                                            field.onChange(data.id)
                                                            setBankValue(data.id)
                                                                ;
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.bank_id && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Bank.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {watchAllFields.issuer_category == 'Financial Institute' &&
                                        <div className={"afrp-field" + (errors.financial_institute_type_id ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconBuilding /> Financial Institute <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="financial_institute_type_id"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <CustomDropdown
                                                        isSearchable={true}
                                                        options={financialInstituteOption}
                                                        selected={financialInstituteValue}
                                                        onChange={(data: any) => {
                                                            field.onChange(data.id)
                                                            setFinancialInstituteValue(data.id);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.financial_institute_type_id && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Financial Institute.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {watchAllFields.issuer_category == 'Public Company' &&
                                        <div className={"afrp-field" + (errors.share_company_id ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconBriefcase /> Public Company <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="share_company_id"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <CustomDropdown
                                                        isSearchable={true}
                                                        options={publicCompanyOption}
                                                        selected={publicCompanyValue}
                                                        onChange={(data: any) => {
                                                            field.onChange(data.id)
                                                            setPublicCompanyValue(data.id);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.share_company_id && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Public Company.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {watchAllFields.issuer_category == 'Insurance Company' &&
                                        <div className={"afrp-field" + (errors.insurance_company_id ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconShield /> Insurance Company <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="insurance_company_id"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <CustomDropdown
                                                        isSearchable={true}
                                                        options={insuranceCompanyOption}
                                                        selected={insuranceCompanyValue}
                                                        onChange={(data: any) => {
                                                            field.onChange(data.id)
                                                            setInsuranceCompanyValue(data.id);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.insurance_company_id && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Insurance Company.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {watchAllFields.issuer_category == 'P2P Lender' &&
                                        <div className={"afrp-field" + (errors.table_id ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconUsers /> P2P Lender <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="table_id"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <CustomDropdown
                                                        isSearchable={true}
                                                        options={p2pLenderOption}
                                                        selected={p2pLenderValue}
                                                        onChange={(data: any) => {
                                                            field.onChange(data.id)
                                                            setP2pLenderValue(data.id);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.table_id && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select P2P Lender.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "Recurring" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "POMIS" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "NPS" || watchAllFields.product_parameter_type == "Superannuation")
                                        &&
                                        <div className={"afrp-field" + (errors.product_name ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconTag /> Product Name <span className="afrp-req">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Product Name"
                                                {...register("product_name", {
                                                    required: true,
                                                })}
                                            />
                                            {errors.product_name && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Enter Product Name.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {(watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "PPF") &&
                                        <div className="afrp-field">
                                            <label className="afrp-lab">
                                                <IconHash /> ISIN Code <span className="afrp-opt">Optional</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="ISIN Code"
                                                {...register("isin_code")}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>

                            {/* ---------- card 2 : terms & preferences ---------- */}
                            <div className="afrp-card">
                                <div className="afrp-card-head">
                                    <div className="afrp-badge">
                                        <IconSliders />
                                    </div>
                                    <div>
                                        <h2>Terms &amp; Preferences</h2>
                                        <p>
                                            Fields marked <span style={{ color: "var(--afrp-red)" }}>*</span> are required
                                        </p>
                                    </div>
                                </div>

                                <div className="afrp-fields">
                                    {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Sukanya Samriddhi" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "PPF" || watchAllFields.product_parameter_type == "NPS" || watchAllFields.product_parameter_type == "Superannuation") &&
                                        <div className={"afrp-field" + (errors.benefit_80C ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconPercent /> 80C Benefit <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="benefit_80C"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <div className="sh-seg">
                                                        <button type="button" className={"sh-seg-opt" + (field.value === "Yes" ? " on" : "")} onClick={() => field.onChange("Yes")}>Yes</button>
                                                        <button type="button" className={"sh-seg-opt" + (field.value === 'No' ? " on" : "")} onClick={() => field.onChange('No')}>No</button>
                                                    </div>
                                                )}
                                            />
                                            {errors.benefit_80C && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select 80C Benefit.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    <div className={"afrp-field afrp-wide" + ((errors.locking_period_by_vendor || errors.locking_period_by_vendor_term) ? " is-invalid" : "")}>
                                        <label className="afrp-lab">
                                            <IconLock /> Locking Period By Vendor <span className="afrp-req">*</span>
                                        </label>
                                        <div className="afrp-inline">
                                            <input
                                                type="text"
                                                className="form-control afrp-inline-num"
                                                {...register("locking_period_by_vendor", {
                                                    required: true,
                                                })}
                                            />
                                            <div className="afrp-inline-sel">
                                                <Controller
                                                    control={control}
                                                    name="locking_period_by_vendor_term"
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <CustomDropdown
                                                            isSearchable={true}
                                                            options={vendorLockingOptions}
                                                            selected={vendorLockingSelected}
                                                            onChange={(data: any) => {
                                                                field.onChange(data.id)
                                                                setVendorLockingSelected(data.id)
                                                                    ;
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        {errors.locking_period_by_vendor && (
                                            <p className="afrp-err">
                                                <IconError /> Please Enter Vendor Locking Period.
                                            </p>
                                        )}
                                        {errors.locking_period_by_vendor_term && (
                                            <p className="afrp-err">
                                                <IconError /> Please Select Vendor Locking Period.
                                            </p>
                                        )}
                                    </div>

                                    {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "Recurring" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "POMIS" || watchAllFields.product_parameter_type == "Sukanya Samriddhi" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "PPF" || watchAllFields.product_parameter_type == "Superannuation") &&
                                        <div className={"afrp-field afrp-wide" + ((errors.locking_period_by_income_tax || errors.locking_period_by_income_tax_term) ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconLock /> Locking Period By Income Tax <span className="afrp-req">*</span>
                                            </label>
                                            <div className="afrp-inline">
                                                <input
                                                    type="text"
                                                    className="form-control afrp-inline-num"
                                                    {...register("locking_period_by_income_tax", {
                                                        required: true,
                                                    })}
                                                />
                                                <div className="afrp-inline-sel">
                                                    <Controller
                                                        control={control}
                                                        name="locking_period_by_income_tax_term"
                                                        rules={{ required: true }}
                                                        render={({ field }) => (
                                                            <CustomDropdown
                                                                isSearchable={true}
                                                                options={vendorLockingOptions}
                                                                selected={lockingIncomeTaxSelected}
                                                                onChange={(data: any) => {
                                                                    field.onChange(data.id)
                                                                    setLockingIncomeTaxSelected(data.id)
                                                                        ;
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            {errors.locking_period_by_income_tax && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Enter Locking Period By Income Tax.
                                                </p>
                                            )}
                                            {errors.locking_period_by_income_tax_term && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Locking Period By Income Tax.
                                                </p>
                                            )}
                                        </div>}

                                    <div className={"afrp-field" + (errors.recommendation ? " is-invalid" : "")}>
                                        <label className="afrp-lab">
                                            <IconStar /> Recommendation <span className="afrp-req">*</span>
                                        </label>
                                        <Controller
                                            control={control}
                                            name="recommendation"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <div className="sh-seg">
                                                    <button type="button" className={"sh-seg-opt" + (field.value === "Yes" ? " on" : "")} onClick={() => field.onChange("Yes")}>Yes</button>
                                                    <button type="button" className={"sh-seg-opt" + (field.value === 'No' ? " on" : "")} onClick={() => field.onChange('No')}>No</button>
                                                    <button type="button" className={"sh-seg-opt" + (field.value === 'NA' ? " on" : "")} onClick={() => field.onChange('NA')}>NA</button>
                                                </div>
                                            )}
                                        />
                                        {errors.recommendation && (
                                            <p className="afrp-err">
                                                <IconError /> Please Select Recommendation.
                                            </p>
                                        )}
                                    </div>

                                    {(watchAllFields.product_parameter_type == "Sukanya Samriddhi" || watchAllFields.product_parameter_type == "PPF") &&
                                        <div className={"afrp-field" + (errors.is_loan_facility_avaliable ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconCash /> Is loan facility available? <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="is_loan_facility_avaliable"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <div className="sh-seg">
                                                        <button type="button" className={"sh-seg-opt" + (field.value === "Yes" ? " on" : "")} onClick={() => field.onChange("Yes")}>Yes</button>
                                                        <button type="button" className={"sh-seg-opt" + (field.value === 'No' ? " on" : "")} onClick={() => field.onChange('No')}>No</button>
                                                    </div>
                                                )}
                                            />
                                            {errors.is_loan_facility_avaliable && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Is loan facility available.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {(watchAllFields.product_parameter_type == "NSC" || watchAllFields.product_parameter_type == "Sukanya Samriddhi" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme" || watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "Recurring" || watchAllFields.product_parameter_type == "EPF" || watchAllFields.product_parameter_type == "PPF") &&
                                        <div className={"afrp-field afrp-wide" + (errors.compounding_frequency ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconRefresh /> Compounding Frequency <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="compounding_frequency"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <div className="sh-seg">
                                                        {compoundingFrequencyOptions &&
                                                            compoundingFrequencyOptions.length > 0 &&
                                                            compoundingFrequencyOptions.map((res: any) => {
                                                                return (
                                                                    <button
                                                                        type="button"
                                                                        key={res.value}
                                                                        className={"sh-seg-opt" + (field.value === res.value ? " on" : "")}
                                                                        onClick={() => field.onChange(res.value)}
                                                                    >
                                                                        {res.value}
                                                                    </button>
                                                                );
                                                            })}
                                                    </div>
                                                )}
                                            />
                                            {errors.compounding_frequency && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Compounding Frequency.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    {(watchAllFields.product_parameter_type == "Fixed" || watchAllFields.product_parameter_type == "POMIS" || watchAllFields.product_parameter_type == "Debentures" || watchAllFields.product_parameter_type == "PO Senior Citizen Scheme") &&
                                        <div className={"afrp-field" + (errors.interest_payout_date ? " is-invalid" : "")}>
                                            <label className="afrp-lab">
                                                <IconCalendar /> Interest Payout Date <span className="afrp-req">*</span>
                                            </label>
                                            <Controller
                                                control={control}
                                                name="interest_payout_date"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <div className="sh-seg">
                                                        <button type="button" className={"sh-seg-opt" + (field.value === 'Start Date' ? " on" : "")} onClick={() => field.onChange('Start Date')}>Start Date</button>
                                                        <button type="button" className={"sh-seg-opt" + (field.value === "End of frequency" ? " on" : "")} onClick={() => field.onChange("End of frequency")}>End of frequency</button>
                                                    </div>
                                                )}
                                            />
                                            {errors.interest_payout_date && (
                                                <p className="afrp-err">
                                                    <IconError /> Please Select Interest Payout Date.
                                                </p>
                                            )}
                                        </div>
                                    }

                                    <div className="afrp-field afrp-wide">
                                        <label className="afrp-lab">
                                            <IconNote /> Notes <span className="afrp-opt">Optional</span>
                                        </label>
                                        <textarea
                                            className="form-control form-control-textarea"
                                            placeholder="Notes"
                                            rows={4}
                                            {...register("notes")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </form>
            </div>
        </>
    );
};
export default AddFixedReturnandRetirementProducts;
